import { CROSS_JOBS } from '../content'
import { anim, prog, stagger } from '../motion'
import { Box, COLORS, Count } from '../primitives'

// Schritte: 0 Überblick · 1 Passung je Stelle (alles Beispieldaten)
const KPIS = [
  { label: 'Eingeladen', value: 48 },
  { label: 'Abgeschlossen', value: 41 },
  { label: 'Ø Passung', value: 73, suffix: ' %' },
  { label: 'Kreuzmatches', value: 6 }
]

const FUNNEL = [
  { label: 'Eingeladen', value: 48, color: COLORS.blue },
  { label: 'Gestartet', value: 45, color: '#546ED4' },
  { label: 'Abgeschlossen', value: 41, color: COLORS.green }
]

const SPREAD = [
  [52, 58, 61, 64, 70, 74, 79, 87],
  [55, 62, 66, 73, 80, 84, 88, 91],
  [48, 57, 61, 66, 70, 78, 84],
  [50, 55, 62, 66, 70, 82]
]
const TRACK = { x: 24, w: 380 }
const avg = (xs) => Math.round(xs.reduce((s, v) => s + v, 0) / xs.length)

export default function SceneData() {
  return (
    <>
      <div
        className='sty-abs sty-sample'
        style={{ left: 820, top: 8, ...anim({ at: [0.02, 0.1], y: 0 }) }}
      >
        Beispieldaten
      </div>

      {KPIS.map((kpi, i) => (
        <Box
          key={kpi.label}
          x={40 + i * 225}
          y={36}
          w={205}
          h={120}
          className='sty-card sty-pad'
          style={anim({ at: stagger(0.02, 0.03, 0.1, i), y: 20 })}
        >
          <div className='sty-muted'>{kpi.label}</div>
          <Count
            to={kpi.value}
            at={stagger(0.04, 0.02, 0.16, i)}
            suffix={kpi.suffix}
            className='sty-kpi'
          />
        </Box>
      ))}

      <Box
        x={40}
        y={186}
        w={430}
        h={414}
        className='sty-card sty-pad-lg'
        style={anim({ at: [0.06, 0.14], x: -30, y: 0 })}
      >
        <div className='sty-eyebrow'>Prozess</div>
        <div className='sty-h4'>Vom Link zum Ergebnis</div>
        {FUNNEL.map((f, i) => (
          <div
            key={f.label}
            className='sty-funnel'
            style={{ top: 110 + i * 82 }}
          >
            <div className='sty-row-between'>
              <span>{f.label}</span>
              <span className='sty-strong'>{f.value}</span>
            </div>
            <div className='sty-funnel__bar'>
              <div
                style={{
                  width: `${(f.value / FUNNEL[0].value) * 100}%`,
                  background: f.color,
                  ...prog(stagger(0.1, 0.03, 0.12, i)),
                  transform: 'scaleX(var(--p))'
                }}
              />
            </div>
          </div>
        ))}
        <div
          className='sty-abs sty-row'
          style={{ left: 28, top: 360, ...anim({ at: [0.18, 0.24], y: 10 }) }}
        >
          <span className='sty-badge sty-badge--green'>
            {Math.round((FUNNEL[2].value / FUNNEL[0].value) * 100)}&nbsp;%
            Abschlussquote
          </span>
        </div>
      </Box>

      <Box
        x={490}
        y={186}
        w={430}
        h={414}
        className='sty-card sty-pad-lg'
        style={anim({ at: [0.52, 0.58], x: 30, y: 0 })}
      >
        <div className='sty-eyebrow'>Passung je Stelle</div>
        <div className='sty-h4'>Wer passt wohin?</div>
        {CROSS_JOBS.map((job, r) => {
          const values = SPREAD[r]
          const mean = avg(values)
          return (
            <div
              key={job}
              className='sty-abs'
              style={{ left: 0, top: 112 + r * 70, width: 430 }}
            >
              <div
                className='sty-row-between'
                style={{ padding: `0 ${TRACK.x + 2}px` }}
              >
                <span className='sty-small'>{job}</span>
                <span
                  className='sty-small sty-strong'
                  style={anim({ at: stagger(0.62, 0.03, 0.06, r), y: 0 })}
                >
                  Ø {mean}&nbsp;%
                </span>
              </div>
              <div
                className='sty-track'
                style={{ left: TRACK.x, top: 34, width: TRACK.w }}
              />
              {values.map((v, i) => (
                <div
                  key={i}
                  className='sty-abs sty-dot sty-dot--sm'
                  style={{
                    left: TRACK.x + (v / 100) * TRACK.w - 5,
                    top: 30,
                    background: v >= 80 ? COLORS.green : COLORS.blue,
                    ...anim({
                      at: stagger(0.55 + r * 0.03, 0.008, 0.05, i),
                      s: 0.2,
                      y: -14
                    })
                  }}
                />
              ))}
              <div
                className='sty-abs sty-mean'
                style={{
                  left: TRACK.x + (mean / 100) * TRACK.w - 1,
                  top: 22,
                  ...anim({ at: stagger(0.62, 0.03, 0.06, r), y: 0, s: 0.2 })
                }}
              />
            </div>
          )
        })}
      </Box>
    </>
  )
}
